import React from 'react';
import { Picture } from '../../../elements/picture/picture';

import { InappmessagesProps, fallbackImage } from '../inappmessages';
import { BodyContent } from './bodyContent';
import styles from '../inappmessages.module.scss';

export function InappmessageModalImageText({
  data,
  onClosePopup,
}: {
  data: InappmessagesProps;
  onClosePopup: Function;
}) {
  const { imageUrl, message, header, buttons, openTarget, imageStyle } = data;
  return (
    <>
      <header className={styles.modalImageWrapper}>
        <Picture
          className={styles.modalImage}
          sizes={[{ url: imageUrl }]}
          lazyLoad={true}
          isAMP={false}
          fallback={fallbackImage}
        ></Picture>
      </header>
      <main className={styles.modalBody}>
        <BodyContent
          title={header || ''}
          description={message || ''}
          buttons={buttons}
          openTarget={openTarget}
          imageStyle={imageStyle}
          onClosePopup={onClosePopup}
          inAppMessage={data}
        />
      </main>
    </>
  );
}
